/**
 * Formats a numeric price as a USD currency string without the `$` prefix.
 *
 * @param price    The price to format.
 * @param decimals Number of fraction digits to display (0 or 2). Defaults to 0.
 *                 - `0` (default): integer formatting; trailing decimals are
 *                   only shown if the underlying value has them (matches the
 *                   prior `currencyFormat` behavior).
 *                 - `2`: always show two fraction digits (matches the prior
 *                   `currencyFormat2` behavior).
 */
export default function currencyFormat(
  price: number,
  decimals: 0 | 2 = 0
): string {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
  };
  if (decimals === 2) {
    options.maximumFractionDigits = 2;
  }
  return new Intl.NumberFormat("en-US", options)
    .format(Number(price))
    .split("$")[1];
}
